import React, { useContext, useState } from "react";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../../assets/css/General/AccountSelection.css";

// Import local images
import trustiDriveLogo from "../../assets/images/TrustiDrivelogo.png";
import customerride from "../../assets/images/customerride.png";
import driverIcon from "../../assets/images/background.png";
import AppContext from "../../context/AppContext";

const AccountSelection = () => {
  const { setSelectedUserTypeForApp } = useContext(AppContext);
  const [selectedType, setSelectedType] = useState(null);
  const navigate = useNavigate();

  const handleContinue = () => {
    if (selectedType === "customer") {
      setSelectedUserTypeForApp("customer");
      localStorage.setItem("actorType", "customer");
      navigate("/customer-login");
    } else if (selectedType === "driver") {
      setSelectedUserTypeForApp("driver");
      localStorage.setItem("actorType", "driver");
      navigate("/driver-login");
    }
  };

  return (
    <div className="account-selection-container">
      <Container className="account-selection-wrapper">
        {/* Logo */}
        <div className="account-selection-logo-section">
          <div className="account-selection-logo">
            <img
              src={trustiDriveLogo}
              alt="TrustiDrive Logo"
              className="account-selection-logo-img"
            />
          </div>
          <p className="account-selection-logo-text">TrustiDrive</p>
        </div>

        {/* Title Section */}
        <div className="account-selection-title-section">
          <h2 className="account-selection-title">Select Account Type</h2>
          <p className="account-selection-subtitle">
            Please choose your account type to continue
          </p>
        </div>

        {/* Account Type Cards */}
        <div className="account-selection-cards">
          {/* Customer Card */}
          <div
            className={`account-selection-card ${selectedType === "customer" ? "account-selection-card--selected" : ""}`}
            onClick={() => setSelectedType("customer")}
          >
            <div className="account-selection-card-image">
              <img
                src={customerride}
                alt="Customer"
                className="account-selection-card-img"
              />
            </div>
            <span className="account-selection-card-label">Customer</span>
          </div>

          {/* Driver Card */}
          <div
            className={`account-selection-card ${selectedType === "driver" ? "account-selection-card--selected" : ""}`}
            onClick={() => setSelectedType("driver")}
          >
            <div className="account-selection-card-image">
              <img
                src={driverIcon}
                alt="Driver"
                className="account-selection-card-img"
              />
            </div>
            <span className="account-selection-card-label">Driver</span>
          </div>
        </div>

        {/* Continue Button */}
        <Button
          className="account-selection-continue-btn"
          onClick={handleContinue}
          disabled={!selectedType}
        >
          Continue
        </Button>
      </Container>
    </div>
  );
};

export default AccountSelection;
